import React from 'react';
import CustomCssManager from '../../CustomCssManager';

export default function CustomCssSection() {
    return (
        <div>
            <div className="sfm-section-header">
                <h2>Custom CSS</h2>
                <p>Add scoped storefront, blog, or custom page styles.</p>
            </div>
            <CustomCssManager />
        </div>
    );
}
